import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from 'src/i18n';
import Quasar from 'quasar/src/vue-plugin.js';; // import { axiosInstance } from 'boot/axios.js'

Vue.use(VueI18n);
var i18nInstance = new VueI18n({
  locale: 'en-us',
  // locale: 'nl-nl',
  // fallbackLocale: 'en-us',
  messages: messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true
});
console.warn('%c[dev suppressions ON]%c\n' + '%c• vue-i18n:%c silentTranslationWarn + silentFallbackWarn — missing keys will NOT show (src/boot/i18n.js)\n' + '%c• ResizeObserver:%c loop errors — window error/unhandledrejection handlers (src/boot/suppress-errors.js)\n' + '%cTurn these off when you want the real warnings back.', 'color:#fbbf24;background:#111827;font-size:14px;font-weight:700;padding:8px 12px 4px;border-radius:4px 4px 0 0;', 'background:#111827;padding:0 12px;', 'color:#34d399;background:#111827;font-size:12px;font-weight:800;padding:2px 0 2px 12px;', 'color:#e5e7eb;background:#111827;font-size:12px;font-weight:500;padding:2px 12px 2px 0;', 'color:#60a5fa;background:#111827;font-size:12px;font-weight:800;padding:2px 0 2px 12px;', 'color:#e5e7eb;background:#111827;font-size:12px;font-weight:500;padding:2px 12px 2px 0;', 'color:#9ca3af;background:#111827;font-size:11px;font-weight:500;font-style:italic;padding:4px 12px 8px;border-radius:0 0 4px 4px;');
export default (function (_ref) {
  var app = _ref.app;
  app.i18n = i18nInstance;
});
export { i18nInstance };
export var setLocale = function setLocale(locale) {
  i18nInstance.locale = locale; // axiosInstance.defaults.headers.common['Accept-Language'] = locale

  import("quasar/lang/".concat(locale)).then(function (lang) {
    Quasar.lang.set(lang.default);
  });
};